export class ReservationCapReachedError extends Error {

  code?: string = 'reservation/cap-reached';
}
